import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationListComponent } from './components/notification-list/notification-list.component';
import { NotificationComponent } from './components/notification/notification.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  declarations: [NotificationListComponent, NotificationComponent],
  imports: [CommonModule, SharedModule],
  exports: [NotificationListComponent]
})
export class NotificationModule { }
